import { ViewChild } from "@angular/core";
import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from "@angular/core";
import { FormsModule } from "@angular/forms";


@Component({
   selector: "my-cloud-page-size",
   templateUrl: "./page-size.component.html",
   styleUrls: ["./page-size.component.scss"],
   imports: [FormsModule]
})
export class PageSizeComponent {
   @ViewChild("inputElement") public inputElement!: ElementRef;

   @Input() public min: number = 1;
   @Input() public max: number = 100;

   @Input() public pageSize: number = 15;
   @Output() public pageSizeChange: EventEmitter<number> = new EventEmitter();

   private get inputValue(): string {
      return this.inputElement.nativeElement.value;
   }

   @HostListener("keyup", ["$event"])
   public onKeyUp(event: KeyboardEvent): void {
      event.preventDefault();
      this.pageSize = Number(this.inputValue);

      if (event.key === "Enter") {
         this.pageSizeInputValueChange(Number(this.inputValue));
      }
   }

   @HostListener("focusout")
   public onFocusOut(): void {
      this.pageSizeInputValueChange(Number(this.inputValue));
   }

   public pageSizeInputValueChange(value: number): void {
      if (value < Number(this.min)) {
         this.pageSize = Number(this.min);
      }

      if (value > Number(this.max)) {
         this.pageSize = Number(this.max);
      }

      if (value >= Number(this.min) && value <= Number(this.max)) {
         this.pageSize = value;
      }

      this.pageSizeChange.emit(this.pageSize);
   }
}
